<template>
	<span class="text" :style="textColor">{{ title }}</span>
</template>

<script>
export default {
	name: 'reason',
	props: {
		title: { required: true, type: String },
		color: { required: false, type: String },
		index: { required: true, type: Number },
	},
	computed: {
		textColor() {
			return {
				'--reasonTextColor': this.color,
			};
		},
	},
};
</script>

<style lang="scss" scoped>
.text {
	max-width: 70%;
	text-align: left;
	color: var(--reasonTextColor);
}
</style>
